import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { LoginCredentials } from '../../models/LoginCredentials';
import api from '../../api/axios';
import { User } from '../../models/User';
import { DecodedToken } from '../../models/DecodedToken';
import { RootState } from '../store';
import { decodeToken } from '../../helperMethods/decodeToken';


interface AuthState {
  user: User | null;
  loading: boolean;
  error: string | null;
}

const initialState: AuthState = {
  user: null,
  loading: false,
  error: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginStart(state) {
      state.loading = true;
      state.error = null;
    },
    loginSuccess(state, action: PayloadAction<User>) {
      state.user = action.payload;
      state.loading = false;
      state.error = null;
    },
    loginFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
    logout(state) {
      state.user = null;
      state.loading = false;
      state.error = null;
      localStorage.removeItem('token');
    },
  },
});
export const login = createAsyncThunk<User, LoginCredentials, { dispatch: any }>(
  'auth/login',
  async (credentials, { dispatch, rejectWithValue }) => {
    try {
      dispatch(loginStart());
      const response = await api.post('/User/login', credentials);
      const token: string = response.data.token;

      localStorage.setItem('token', token);

      const decoded: DecodedToken = decodeToken(token);

      const user: User = {
        id: decoded.id,
        username: decoded.username,
        email: decoded.email,
        isAdmin:decoded.isAdmin === "True",
        isEsimReseller:decoded.isEsimReseller === "True",
        showPrices: decoded.showPrices === "True",
        role: decoded.role,
        token,
      };

      dispatch(loginSuccess(user));
      return user
    } catch (error: any) {
      const errorMessage = error.displayMessage || error.response?.data?.message || 'Login failed';
      dispatch(loginFailure(errorMessage));
      return rejectWithValue(errorMessage);
    }
  }
);

export const loadUserFromStorage = createAsyncThunk<void, void, { dispatch: any }>(
  'auth/loadUserFromStorage',
  async (_, { dispatch }) => {
    const token = localStorage.getItem('token');
    if (!token) {
      return;
    }

    try {
      const decoded: DecodedToken = decodeToken(token);
      const user: User = {
        id: decoded.id,
        username: decoded.username,
        email: decoded.email,
        isAdmin:decoded.isAdmin === "True",
        isEsimReseller:decoded.isEsimReseller === "True",
        showPrices: decoded.showPrices === "True",
        role: decoded.role,
        token,
      };
      dispatch(loginSuccess(user));
    } catch (error) {
      localStorage.removeItem('token');
    }
  }
);

export const { loginStart, loginSuccess, loginFailure, logout } = authSlice.actions;
export default authSlice.reducer;
